{
  "version": 1,
  "asset_id": "7444484e-8111-405d-870b-4e066458374c",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7444484e-8111-405d-870b-4e066458374c/hiatal-intro-fundus-en-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7444484e-8111-405d-870b-4e066458374c/hiatal-intro-fundus-en-480.webp",
  "original_filename": "hiatal-intro-fundus-en-480.webp",
  "size": 21840,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:54:31Z"
}
